import React, { Component } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import { browserHistory } from 'react-router';
import moment from 'moment';
import Header from '../components/Header';
import ChangingProgressProvider from '../components/SyncData/ChangingProgressProvider';
import withNotify from '../common/withNotify';
import withOnline from '../common/withOnline';
import withGoBack from '../common/withGoBack';
import Bugsnag from '../helpers/bugsnag';
import SyncOnlineNotify from '../components/Models/SyncOnlineNotify';
import {
  onGoBack,
  storeSyncDate,
  storeSyncTeamAbb,
  getUser,
  getAuthToken,
  getServerUrl,
  getFirstLoginToken,
  storeVersionCode,
  getThemeColor,
  getThemeColorNumber,
  storeThemeColor,
  storeThemeColorNumber,
} from '../common/globals';
import {
  setData,
  syncCases,
} from '../utils/db.js';
import {
  syncData
} from '../utils/utils';
import withSalesYTD from '../common/withSalesYTD.js';
import withMenu from '../common/withMenu';
import withUser from '../common/withUser';
import withServerUrl from '../common/withServerUrl';
import withLoader from '../common/withLoader';
import withTeam from '../common/withTeam';
import EarlyAccessMessageModal from '../components/Models/EarlyAccessMessageModal';

let intervalId = 0;

class SyncData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      syncStatus: [
        'Sync data...',
        'Sync data - Surgeons...',
        'Sync data - Hospitals...',
        'Sync data - Components...',
        'Sync data - Preferences...',
        'Sync data - Device Types...',
        'Sync data - Case Types...',
        'Sync data - Procedure Types...',
        'Sync data - Cases...',
        'Sync data - Sets...',
        'Sync data - Rep Reports...',
        'Sync data - Team Reps...',
        'Sync data - Product Master...',
        'Sync data - Type Options...',
        'Sync data - SetMasterGroup...'
      ],
      syncProgressStatus: [],
      downloadingStatus: false,
      syncProgress: [],
      arrayLength: 0,
      earlyAccessMessage: 'Your team is on the Production version of the website. Please use the button below to open the link.',
      earlyAccessURL: ''
    };
    this.clearInterval = 0;
    this.SyncOnlineNotify = null;
    this.EarlyAccessMessageModal = null;
  }

  componentDidMount() {
    try {
      this.EarlyAccessMessageModal = new window.bootstrap.Modal(window.$('#EarlyAccessMessageModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onManageCases = () => {
    try {
      setTimeout(() => {
        browserHistory.push('/manage-cases');
      }, 500);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onLogout = async () => {
    try {
      const {
        setLoader, setTeam, online
      } = this.props;

      const color = await getThemeColor();
      const colorNumber = await getThemeColorNumber();
      if (online) {
        setLoader(true);
        setTeam({});
        window.localStorage.clear();
        await storeThemeColor(color);
        await storeThemeColorNumber(colorNumber);
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOpenURL = async () => {
    try {
      setTimeout(() => {
        window.location.replace(this.state.earlyAccessURL);
      }, 1000);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        online, notify, setSalesYTD,
        user: { territories, selectedTeam, territoryId }
      } = this.props;

      if (online) {
        this.setState({
          downloadingStatus: true,
          syncProgress: 10
        });
        await syncCases();
        await storeVersionCode();
        this.setState({
          syncProgress: 30
        });
        syncData({ start_date: moment().startOf('month').format('YYYY-MM-DD') })
          .then(async (response) => {
            const {
              appDownloadLink, appTypeRequired
            } = response;

            if (appTypeRequired === 'website') {
              const currentURL = window.location.origin;
              if (currentURL !== appDownloadLink) {
                territories.map((item) => {
                  if (item.id === territoryId) {
                    if (item.hasOwnProperty('offices')) {
                      item.offices.map((office) => {
                        if (office.hasOwnProperty('teams')) {
                          office.teams.map((team) => {
                            if (team.isEarlyAccess && team.id === selectedTeam.id) {
                              this.setState({
                                earlyAccessMessage: 'Your team is on the Early Access version of the website. Please use the button below to open the link.'
                              });
                            }
                          });
                        }
                      });
                    }
                  }
                });

                const userData = await getUser();
                const authToken = await getAuthToken();
                const serverUrl = await getServerUrl();
                const firstLoginToken = await getFirstLoginToken();

                // Sample object
                const objectToEncode = {
                  token: authToken,
                  userId: userData.id,
                  office: userData.office,
                  team: userData.team,
                  territoryId: userData.territoryId,
                  url: btoa(serverUrl),
                  firstToken: firstLoginToken,
                };

                // Serialize object to JSON string
                const jsonString = JSON.stringify(objectToEncode);

                this.setState({
                  earlyAccessURL: `${appDownloadLink}?auto-login=${btoa(jsonString)}`
                });
                await this._onLogout();
                setTimeout(() => {
                  this.EarlyAccessMessageModal.show();
                }, 1000);
                return false;
              }
            }

            this.setState({
              syncProgress: 40
            });
            const {
              status, data, message, team_abb, ytd
            } = response;
            // TODO: If return error in sync API then ?
            if (status) {
              setSalesYTD(ytd);
              await setData(data);
              storeSyncDate(moment().toISOString());
              storeSyncTeamAbb(team_abb);
              const { syncStatus, syncProgressStatus } = this.state;
              this.clearInterval = setInterval(() => {
                this.setState({
                  syncStatus
                });
                intervalId = (intervalId + 1) % syncStatus.length;
                syncProgressStatus.push(syncStatus[intervalId]);

                if (syncProgressStatus.length === syncStatus.length) {
                  clearInterval(this.clearInterval);
                }
                if (intervalId > 0) {
                  this.setState({
                    syncProgress: (intervalId * 5) + 30,
                    arrayLength: intervalId
                  });
                }
              }, 100);
              this.SyncOnlineNotify = new window.bootstrap.Modal(window.$('#syncOnlineNotifyModal'));
            } else {
              notify({ type: 'error', message });
            }
          });
      } else {
        this.SyncOnlineNotify.show();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      syncProgressStatus, downloadingStatus, syncProgress, arrayLength
    } = this.state;
    const { goBack } = this.props;
    return (
      <section className="list-section">
        {
          goBack.length === 0
            ? (
              <Header
                sideMenu
                goForward={{ url: '/manage-cases' }}
              />
            )
            : goBack.length >= 1
              ? (
                <Header
                  goBack={() => onGoBack(goBack)}
                  goForward={{ url: '/manage-cases' }}
                />
              )
              : (
                <Header
                  logout
                  goForward={{ url: '/manage-cases' }}
                />
              )
        }
        <section className="sync-data-section">
          <div className="container">
            <div className="progressbar">
              <div className="second circle">
                {
                  !downloadingStatus
                  && (
                    <ChangingProgressProvider
                      values={[0]}
                    >
                      {() => (
                        <CircularProgressbar value={0} text={`${0}%`} />
                      )}
                    </ChangingProgressProvider>
                  )
                }

                {
                  downloadingStatus
                  && (
                    <ChangingProgressProvider
                      values={[syncProgress]}
                      onManageCases={this._onManageCases}
                      downloadingStatus={downloadingStatus}
                      intervalId={arrayLength}
                    >
                      {(percentage) => (
                        <CircularProgressbar value={percentage} text={`${percentage}%`} />
                      )}
                    </ChangingProgressProvider>
                  )
                }
              </div>
            </div>
            <div className="row">
              <div className="col-8">
                {
                  downloadingStatus && <p style={{ fontWeight: '600' }}>Downloading data...</p>
                }

                {
                  downloadingStatus && syncProgressStatus.map((item, key) => (
                    <p key={key}>{item}</p>
                  ))
                }
              </div>
            </div>
          </div>
        </section>
        <SyncOnlineNotify
          onClickOk={this._onManageCases}
        />
        <EarlyAccessMessageModal
          message={this.state.earlyAccessMessage}
          onPressOkay={this._onOpenURL}
        />
      </section>
    );
  }
}

export default withGoBack(
  withOnline(
    withNotify(
      withSalesYTD(
        withTeam(
          withLoader(
            withServerUrl(
              withUser(
                withMenu(
                  SyncData
                )
              )
            )
          )
        )
      )
    )
  )
);
